import {productPage} from "../modules/elements.js";
import {getElement,} from "../modules/helpers.js";
import {findVariationInProducts, objectAttributesCreate} from "./productItem.js";
import {installmentCalc, productItem, calcCashBack} from "./renderProductInfo.js";


export default function productPageIncludes() {
    const includesParent = productPage.querySelector(".includes-section");
    if (!includesParent) return;
    const {fas, currency} = product;
    const priceParent = getElement('[data-variation-price]')
    const currentCurrency = currency;
    const mainFas = getElement('[data-fas]');
    if (fas) {
        productItem.querySelector('[data-dropdown]').querySelector('[data-modal="alternatives"]').remove()
        productItem.firstElementChild.insertAdjacentHTML('beforeend', `<div class="product-item__includes  product-item--line border--bottom"><div class="flex --just-between  --align-center"><div class="mr-10">Kit includes <span class="text-color__black--60" data-includes-count>${Object.keys(fas).length}</span> items</div> <a href="#includes" class="flex --align-center scroll-to text-color__black--60"> <span class="mr-5">Customize</span> <span class="icon-arrow-right icon-12"></span> </a></div></div>`
        );

        for (let key in fas) {
            includesParent.append(renderIncludesItem(key, fas[key], objectAttributesCreate(mainFas)))
        }
        renderFasPrice()
        installmentCalc(mainFas);
        calcCashBack(mainFas)
        const attributesElements = getElement('[data-fas]').querySelector('.product-item__attributes').querySelectorAll('[data-select]');
        attributesElements.forEach(item => {
            const btns = item.querySelectorAll('button');
            btns.forEach(btn => {
                btn.addEventListener('click', () => {
                    getElement('.includes-item', true).forEach(includeItem => {
                        for (let key in fas) {
                            if (key === includeItem.parentElement.dataset.product) {
                                const {
                                    price,
                                    regular_price,
                                    attributes,
                                    id
                                } = createIncludesVariations(fas[key], objectAttributesCreate(mainFas))
                                includeItem.parentElement.dataset.includesId = id;
                                includeItem.querySelector('[data-include-price]').dataset.includePrice = Math.round(+price);
                                includeItem.querySelector('[data-include-price]').dataset.priceNew = Math.round(+price);

                                includeItem.querySelector('[data-include-price]').innerHTML = `${currentCurrency}${Math.round(+price)}`
                                includeItem.querySelector('[data-include-price]').nextElementSibling.dataset.priceOld = Math.round(+regular_price);
                                includeItem.querySelector('[data-include-price]').nextElementSibling.innerHTML = `${regular_price !== '' && price != regular_price ? currentCurrency + Math.round(+regular_price) : ''}`
                                includeItem.querySelector('[data-href]').href = createLinkAttr(attributes, includeItem.querySelector('[data-href]').dataset.href)
                            }
                        }
                        if (includeItem.classList.contains('active')) {
                            renderFasPrice()
                        }
                        installmentCalc(mainFas)
                        calcCashBack(mainFas)
                        includeItemsCount()
                    })


                });

            })
        });
        const btns = includesParent.querySelectorAll("button");
        btns.forEach((btn) => {
            btn.addEventListener("click", () => {
                btn.parentElement.classList.toggle("active");
                renderFasPrice()
                installmentCalc(mainFas)
                includeItemsCount()
                calcCashBack(mainFas)
            });
        });
    }

    function createIncludesVariations(item, fasObj) {
        if (!item) return;
        const {attributes: {variationsAttributes},} = item;
        let variation = {};
        for (let key of variationsAttributes) {
            for (let attr in fasObj) {
                if (attr == key) {
                    variation[key] = fasObj[key]
                }
            }
        }
        if (findVariationInProducts(variation, item)) {
            variation = findVariationInProducts(variation, item)
        } else {
            const {variations} = item;
            if (variation['pa_protection-level']) {
                variation = variations.find(variationProduct => {
                    const {attributes} = variationProduct;
                    if (attributes['pa_size'].indexOf(variation['pa_size']) >= 0 && attributes['pa_protection-level'] === variation['pa_protection-level'] && attributes['pa_color'] === variation['pa_color']) return variationProduct;
                })
            } else {
                variation = variations.find(variationProduct => {
                    const {attributes} = variationProduct;
                    if (attributes['pa_cummerbund'] === "armored" && attributes['pa_color'] === variation['pa_color'] && attributes['pa_size'] === variation['pa_size'] && attributes['pa_cummerbund-size'] === variation['pa_size']) return variationProduct
                })
            }
        }
        return variation;
    }

    function includeItemsCount() {
        getElement('[data-includes-count]').innerText = getElement('.includes-item.active', true).length;
    }

    function createLinkAttr(attributes, link) {
        let str = '';
        for (let key in attributes) {
            str += `attribute_${key}=${attributes[key]}&`
        }
        return `${link}?${str}`
    }


    function renderIncludesItem(key, item, fasObj) {
        if (!item) return;
        const {title, thumbnail, link} = item;

        let variation = createIncludesVariations(item, fasObj);

        const {price, regular_price, attributes, id} = variation;

        const href = createLinkAttr(attributes, link);
        const div = document.createElement('div');
        div.classList = 'includes-section__item border--bottom';
        div.dataset.includesId = id;
        div.dataset.product = key;
        div.innerHTML = `
    <div class="includes-item active">
      <div class="includes-item__preview">
        <div class="image">
          <img src="${thumbnail}" alt="${title}">
        </div>
      </div>
      <div class="includes-item__name fw-600">
        <a href="${href}" class="mb-5 text-color__black txt-no-underline" data-href="${link}">
         ${title}
        </a>
        <div class="text-color__black--60 flex --align-end" >
             <div data-include-price="${price}" data-price-new="${price}" class=" h2 fw-600 mr-10">${currency}${Math.round(+price)}</div>
                <s class="h5" data-price-old="${regular_price}">${regular_price !== '' && price != regular_price ? currency + Math.round(+regular_price) : ''}</s>
        </div>
      </div>
      <button class="includes-item__btn"></button>
    </div>
        
`
        return div;
    }


    function renderFasPrice() {
        let price = 0;
        let regularPrice = 0;
        includesParent.querySelectorAll('[data-include-price]').forEach(item => {
            if (item.parentElement.closest('.includes-item').classList.contains('active')) {
                price += +item.dataset.priceNew;
                regularPrice += +item.nextElementSibling.dataset.priceOld;

            }
        })
        priceParent.dataset.productPrice = Math.round(price);
        priceParent.dataset.variationPrice = Math.round(price);
        priceParent.innerHTML = `${currentCurrency}${Math.round(price)}`
        priceParent.nextElementSibling.innerHTML = `${regularPrice && price !== regularPrice ? currentCurrency + Math.round(+regularPrice) : ''}`;
        priceParent.nextElementSibling.dataset.priceOld = Math.round(+regularPrice);
        const discount = Math.round((1 - +price / +regularPrice) * 100);
        if (discount) {
            getElement('[data-product-discount]').innerText = `${discount}%`
        }
    }


}
// export {renderFasPrice}